import { cx } from 'class-variance-authority'
import { PageProps } from 'gatsby'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useUIStore } from '../../stores/ui/uiStore'
import { ApplicationModalForm } from '../application/ApplicationModalForm'
import { LikesBanner } from '../banner/LikesBanner'
import { NewClientNotificationSubscriptionModal } from '../notification/NewClientNotificationSubscriptionModal'
import { AudioPlayer } from '../podcast/audio/player/AudioPlayer'
import { Footer } from './footer'
import { Header } from './header'

interface LayoutProps {
  children: React.ReactNode
  careerSite?: boolean
  hideFooter?: boolean
  colorCareerSite?: string
  apiUrl?: string
  apiToken?: string
  CustomHeader?: React.ReactNode
  location?: PageProps['location']
}

const Layout: React.FC<LayoutProps> = ({
  children,
  careerSite = false,
  hideFooter,
  colorCareerSite = undefined,
  CustomHeader = undefined,
  apiToken,
  apiUrl,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  location,
}) => {
  const isAudioPlayerSmall = useUIStore.use.isAudioPlayerSmall()

  return (
    <ErrorBoundary fallbackRender={({ error }) => {
      console.error('Error in layout', error)
      return null
    }}>
      <div className="flex flex-col h-full min-h-screen">
        {CustomHeader || <Header hasCareerSite={careerSite} />}
        {!careerSite && <LikesBanner />}

        <main className="grow">{children}</main>
        <Footer
          isHidden={hideFooter}
          careerSite={careerSite}
          colorCareerSite={colorCareerSite}
        />
        <div
          className={cx(
            'fixed inset-x-0 bottom-0 z-10 transform ease-in-out transition-all duration-300',
            isAudioPlayerSmall
              ? 'md:left-[85%] lg:left-[90%]'
              : 'lg:left-112 xl:left-120',
          )}
        >
          <AudioPlayer />
        </div>
      </div>
      <ApplicationModalForm
        backendUrl={apiUrl || ''}
        frontStrapiToken={apiToken || ''}
      />
      <NewClientNotificationSubscriptionModal
        backendUrl={apiUrl || ''}
        frontStrapiToken={apiToken || ''}
      />
    </ErrorBoundary>
  )
}

export default Layout
